import api from '../../api'

// Utilities
import Language from '../../utility/languageUtil'
import Logger from '../../utility/loggerUtil'

export default {
  async getStoreDetails (context, storeId) {
    try {
      const storeDetails = (await api.store.getStoreDetails(storeId))

      Logger.info('Got Store Details')
      Logger.debug(storeDetails)

      context.commit('addStore', storeDetails)

      return storeDetails
    } catch (e) {
      Logger.error('Failed to get store details')
      Logger.debug(e)

      throw new Error(`${Language.$t('global.get_store_details_query_error')}: ${e.message}`)
    }
  }
}
